import React from 'react';
import { TableCellProps } from '../../../types/search';
import { frequencyParts } from '../utils/tableCellUtils';

const PortalCellFrequency: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  const { frequency, day } = frequencyParts(value);

  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--frequency`}>
      <div className="portal-cell__icon">
        <svg className="icon" aria-hidden="true">
          <use href="/dist/assets/icons/sprite.svg#refresh-double"></use>
        </svg>
      </div>
      <div>
        <p>
          <strong>{frequency}</strong>
        </p>
        {day && <p>Every {day}</p>}
      </div>
    </div>
  );
};

export default PortalCellFrequency;
